import { render, staticRenderFns } from "./66.vue?vue&type=template&id=39dcb2e5&scoped=true&"
var script = {}
import style0 from "./66.vue?vue&type=style&index=0&id=39dcb2e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dcb2e5",
  null
  
)

export default component.exports